import styled from 'styled-components';

const InviteList = styled.ul`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
`;

export default InviteList;
